import { IReportItem } from '@modules/factor/dialogs/factor-report-dialog/component/factor-report-dialog.interface';

export const FactorReportDialogComponent_AddItemButtons = 'FactorReportDialogComponent_AddItemButtons';
export const FactorReportDialogComponent_ButtonClick = 'FactorReportDialogComponent_ButtonClick';

/**
 * Компонент FactorReportDialogComponent, хук AddItemButtons
 */
export interface IFactorReportDialogComponent_AddItemButtons {
    /** Список элементов формы печатных отчётов */
    items: IReportItem[];
}

/**
 * Компонент FactorReportDialogComponent, хук ButtonClick
 */
export interface IFactorReportDialogComponent_ButtonClick {
    /** Элемент списка, по кнопке которого кликнули */
    item: IReportItem;
    /** Команда, ассоциированая с кнопкой (IButtonExtended.click) */
    command: string;
}
